import React from 'react';
import { NavLink, Link } from 'react-router-dom';


const Factory = ( model, rolePermissions, user, setIsUserMenuOpen, metadata ) => {
  return (
    <>
      {( () => {

        const item = model[ 'settings' ];

        return (
          <NavLink className="topbar-user-menu-link" onClick={() => setIsUserMenuOpen(false)} to={item.path}>
            {item.title}
          </NavLink>
        );
      } )()}

      {( () => {

        const item = model[ 'users' ];

        return rolePermissions.hasPermission(user, 'users.manage') ? (
          <NavLink className="topbar-user-menu-link" onClick={() => setIsUserMenuOpen(false)} to={item.path}>
            {item.title}
          </NavLink>
        ) : null;
      } )()}
    </>
  );
};

export default Factory;

